import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  environment,
  MyHttpClientFactory,
  ResponseCasingEnum,
} from '@ups/xplat/core';

export interface WarehouseAdministrator {
  warehouseAdministratorId: string;
  warehouseId: number;
  email: string;
  isActive: boolean;
}

const BASE_URL = '/api/warehouseAdministrators';

@Injectable({
  providedIn: 'root',
})
export class WarehouseAdministratorService {
  private http: HttpClient;

  constructor(httpClientFactory: MyHttpClientFactory) {
    this.http = httpClientFactory.createHttpClient(
      environment.urls.toolTrackerAPI,
      true,
      ResponseCasingEnum.CamelCase
    );
  }

  getForWarehouse(warehouseId: number): Observable<WarehouseAdministrator[]> {
    return this.http.get<WarehouseAdministrator[]>(
      `${BASE_URL}/warehouse/${warehouseId}`
    );
  }

  /** Replaces the full admin email list for the given warehouse. Returns the new list. */
  replaceForWarehouse(
    warehouseId: number,
    emails: string[]
  ): Observable<WarehouseAdministrator[]> {
    return this.http.put<WarehouseAdministrator[]>(
      `${BASE_URL}/warehouse/${warehouseId}`,
      emails
    );
  }
}
